'use client'

import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchCoinMarketCalEvents } from '@/service/coinmarketcal.api'
import type { CoinMarketCalHistoryParams } from '@/service/coinmarketcal.types'
import { snapshotAndUpdateQueryOptions } from '@/service/snapshot-query-options'
import type { CoinMarketCalEventList } from '@/types/generated/public_api'

export { useCoinMarketCalEventStream } from '@/service/ws/use-coinmarketcal-event-stream'

const COINMARKETCAL_DEFAULT_LIMIT = 100

export const coinMarketCalKeys = {
  all: ['coinmarketcal'] as const,
  history: (params: CoinMarketCalHistoryParams) =>
    [...coinMarketCalKeys.all, 'history', params] as const,
}

export function useCoinMarketCalEventsInfinite(params: CoinMarketCalHistoryParams, enabled = true) {
  const limit = params.limit ?? COINMARKETCAL_DEFAULT_LIMIT
  return useInfiniteQuery<CoinMarketCalEventList>({
    queryKey: coinMarketCalKeys.history(params),
    queryFn: ({ pageParam = 0 }) =>
      fetchCoinMarketCalEvents({
        ...params,
        limit,
        offset: pageParam as number,
      }),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.events.length < limit) return undefined
      return allPages.length * limit
    },
    initialPageParam: 0,
    enabled,
    ...snapshotAndUpdateQueryOptions,
  })
}
